import React, { useState } from "react";
import ModelViewer from "./components/ModelViewer";
import Circle from "./components/Circle";
import PageOne from "./components/PageOne";
import PageTwo from "./components/PageTwo";
import PageThree from "./components/PageThree";
import Header from "./components/Header";
import SideBySide from "./components/SideBySide";
import SxSContainer from "./components/SxSContainer";
import Logos from "./components/Logos";
import VideoPlayer from "./components/VideoPlayer";
import { Parallax, ParallaxLayer } from "react-spring/renderprops-addons";
import "./App.scss";

function App() {
  return (
    <div className="App">
      <Parallax pages={8.25} vertical>
        {/* 1 */}
        <ParallaxLayer offset={0.9} speed={0.4}>
          <div className="big-circle"></div>
        </ParallaxLayer>
        <ParallaxLayer offset={-0.02} speed={0.4}>
          <Circle width={"130vmin"} height={"130vmin"} left={"50%"}></Circle>
        </ParallaxLayer>
        <ParallaxLayer offset={0} speed={0.3}>
          <Header />
        </ParallaxLayer>
        <ParallaxLayer offset={0.9} speed={0.2}>
          <Circle width={"18vw"} height={"18vw"} left={"-10vw"} />
        </ParallaxLayer>

        <ParallaxLayer offset={1} speed={0.2}>
          <ParallaxLayer offset={0.05} speed={0.1}>
            <Circle width={50} height={50} left={"25vw"}></Circle>
          </ParallaxLayer>
          <ParallaxLayer offset={0.9} speed={0.3}>
            <Circle width={"80vmin"} height={"80vmin"} left={"-200px"}></Circle>
          </ParallaxLayer>
          <ParallaxLayer offset={0.6} speed={0.1}>
            <div className="caleb"></div>
          </ParallaxLayer>
          <ParallaxLayer offset={0.8} speed={0.3}>
            <Circle width={75} height={75} left={"80vw"}></Circle>
          </ParallaxLayer>
          <ParallaxLayer offset={0.7} speed={0.1}>
            <img src="/img/quote.svg" className="quote" alt="quotation" />
            {/* <h4>"</h4> */}
          </ParallaxLayer>
          <PageOne />
        </ParallaxLayer>

        <ParallaxLayer offset={2} speed={0.2}>
          <ParallaxLayer offset={0.9} speed={0.1}>
            <div className="jazzy"></div>
          </ParallaxLayer>
          <ParallaxLayer offset={0.9} speed={0.3}>
            <Circle width={40} height={40} left={"65vw"}></Circle>
          </ParallaxLayer>
          <ParallaxLayer offset={-0.1}>
            <PageTwo />
          </ParallaxLayer>
        </ParallaxLayer>

        <ParallaxLayer offset={3.7} speed={0.4}>
          <Circle width={"10vmin"} height={"10vmin"} left={"72vw"} />
        </ParallaxLayer>

        <ParallaxLayer offset={3} speed={0.22}>
          <ParallaxLayer offset={-0.1}>
            <PageThree />
          </ParallaxLayer>
        </ParallaxLayer>

        <ParallaxLayer offset={4} speed={0}>
          {/* 3 */}
          <ModelViewer
            width={"100%"}
            height={600}
            options={[
              "Annika",
              "Caleb",
              "Chandler",
              "David",
              "Deuce",
              "Eli",
              "Jazzy",
              "Joel",
              "Madison",
              "Matthew",
              "Quincy",
              "Shaurya"
            ]}
          />
        </ParallaxLayer>
        {/* <ParallaxLayer offset={5} speed={0.5}>
            <div className="callout-copy">
              <h1>
                Every day at St. Jude Children’s Research Hospital we witness extraordinary bravery. Kids in a battle for
                their lives, showing courage and determination that inspires us all.
              </h1>
            </div>
          </ParallaxLayer> */}
        <ParallaxLayer offset={5} speed={0}>
          <VideoPlayer width={"100%"} height={"100%"} />
        </ParallaxLayer>

        {/* <ParallaxLayer speed={0.3} offset={7.35}>
            <Circle width={40} height={40} left={"45vw"}></Circle>
          </ParallaxLayer> */}

        <ParallaxLayer offset={6.25} speed={0}>
          <SideBySide
            orientation="left"
            headline="Experience it in Virtual Reality"
            paragraph="If you own a Oculus Quest, Oculus Rift or Oculus Rift S you can experience St. Jude Hall of Heroes by downloading the app from the Oculus Store."
            buttonText="Learn More"
            imageUrl="/img/rift_s.png"
            alt="oculus rift"
            rightImgWidth="100%"
            showButton={true}
            link={"https://www.oculus.com/experiences/quest/2941596479246841/"}
          ></SideBySide>
        </ParallaxLayer>
        <ParallaxLayer offset={6.75} speed={0}>
          <SideBySide
            orientation="right"
            headline="About St. Jude Children's Research Hospital&reg;"
            paragraph="St. Jude won’t stop until no child dies of cancer. Click the link below to find out more about St. Jude and how you can help."
            buttonText="Learn More &amp; Donate"
            imageUrl="/img/sj_logo.svg"
            alt="St Jude Childrens Research Hospital"
            leftImgWidth="70%"
            showButton={true}
            link={"https://www.stjude.org/get-involved/other-ways/hall-of-heroes-vr.html"}
          ></SideBySide>
        </ParallaxLayer>

        <ParallaxLayer offset={7.25} speed={0}>
          <SideBySide
            orientation="right"
            headline="Bring the statues into the real world"
            paragraph="There’s also a Facebook and Instagram AR lens. Using your phone, you can place your favorite statue wherever you like, pose with it, and share it. Use #hallofheroes so we can see too."
            buttonText="Learn More &amp; Donate"
            imageUrl="/img/ar_img.png"
            alt="St Jude Childrens Research Hospital"
            leftImgWidth="100%"
          ></SideBySide>
        </ParallaxLayer>

        <ParallaxLayer offset={8} speed={0}>
          <Logos />
        </ParallaxLayer>
      </Parallax>
    </div>
  );
  // }
}

export default App;
